// extracted by mini-css-extract-plugin
export default {"exerciseCardTopBar":"ExerciseCardTopBar_exerciseCardTopBar__wbOCp"};